exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.not-found-screen .v-content {\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n}\n.not-found-screen .v-content__wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 4em;\n}\n", ""]);

// exports
